// import { createAction, props, union } from '../util/actions/action-creator.util';

import { createActionCreator } from 'deox';
import { PlacementConfig } from '../models/placement-config.model';
import { PlacementMetadata } from '../models/placement-meta-data.model';
import { GeneratePlacementResponse } from '@ads-ep/fetch-api-client';
import { PlacementTemplateActions } from './placement-action-reducer';

export const showOverlay = createActionCreator(
  'SHOW_OVERLAY', resolve => (payload: {
    actionContentId: string,
    placementConfig: PlacementConfig,
    placementMetaData: PlacementMetadata,
    brandPresentmentConfig: GeneratePlacementResponse
  }) =>
    resolve(payload),
);

export const showOverlayAuxEvent = createActionCreator(
  'SHOW_OVERLAY_AUX_EVENT',
);

export const closeOverlay = createActionCreator(
  'CLOSE_OVERLAY',
  resolve => (dismissTarget?: HTMLDivElement, locked = false) => resolve({dismissTarget, locked}),
);

export const setOverlayDisposeLock = createActionCreator(
  'SET_OVERLAY_DISPOSE_LOCK',
  resolve => (lockOverlay: boolean, dismissTarget?: HTMLDivElement) => resolve({lockOverlay, dismissTarget}),
);

export const setOverlayIframe = createActionCreator(
  'SET_OVERLAY_IFRAME',
  resolve => (payload: {}) => resolve(payload),
);

/*
* Move to own file
* */
export const breadApply = createActionCreator(
  'BREAD_APPLY'
);

export const breadApplyInit = createActionCreator(
  'BREAD_APPLY_INIT',
);